module.exports = __webpack_public_path__ + "media/registration/check-mark-d5142ea7.svg";